import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isNil from 'lodash/isNil';

import { IconWithDotBadge } from 'shared/components';
import { getCloseTimeFormatted, getDurationFormatted } from 'shared/utils/dateTimeUtils';

import { getConversationTypeTitle } from 'modules/conference/constants/conversationsTypesTitles';
import { CONVERSATION_STATUS_TITLES } from 'modules/queues/constants/conversationStatusTitles';
import * as conversationTypes from 'modules/queues/constants/conversationTypes';

import { inProgressStatuses, upcomingConsultationStatuses, PENDING } from 'modules/common/constants/conversationStatuses';

import theme from './ConversationItem.scss';

const propTypes = {
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

const defaultProps = {};

const ConversationItem = ({
  start,
  end,
  type,
  status,
  intl,
}) => {
  if (status === 'CREATED' || isNil(start)) return null;

  const { title, iconName } = CONVERSATION_STATUS_TITLES[status];
  const conversationTypeTitle = getConversationTypeTitle(type);

  return (
    <div className={ theme.root }>
      <div className={ theme.infoRow }>
        <div className={ theme.icon }>
          <IconWithDotBadge
            name={ iconName }
            withoutBackground
            iconFontSize="20px"
            iconWidth="20px"
          />
        </div>

        <div className={ theme.title }>
          <FormattedMessage { ...title } />

          <span className={ theme.subtitle }>
            { getCloseTimeFormatted(start, intl) }
          </span>
        </div>
      </div>
      <If condition={ ![...inProgressStatuses, ...upcomingConsultationStatuses, PENDING].includes(status) }>
        <div className={ theme.infoRow }>
          <div className={ theme.icon }>
            <IconWithDotBadge
              name="hourglass"
              withoutBackground
              iconFontSize="20px"
              iconWidth="20px"
            />
          </div>

          <div className={ theme.title }>
            { isNil(end) ? '00:00' : getDurationFormatted(start, end, intl) }
          </div>
        </div>
      </If>
      <div className={ theme.infoRow }>
        <div className={ theme.icon }>
          <IconWithDotBadge
            name={ type === conversationTypes.AUDIO_EXTERNAL ? 'answer' : 'vidcam' }
            withoutBackground
            iconFontSize="20px"
            iconWidth="20px"
          />
        </div>

        <div className={ theme.title }>
          <FormattedMessage { ...conversationTypeTitle } />
        </div>
      </div>
    </div>
  );
};

ConversationItem.propTypes = propTypes;
ConversationItem.defaultProps = defaultProps;

export default ConversationItem;
